<template>
  <div v-loading="isLoading">
    <el-table
      :data="locations"
      stripe
    >
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-row :gutter="10">
            <el-col :md="8">
              <p><strong>Name: </strong>{{ props.row.name || 'None' }}</p>
              <p><strong>Address: </strong>{{ props.row.address || 'None' }}</p>
              <p><strong>Suburb: </strong>{{ props.row.suburb || 'None' }}</p>
              <p><strong>State: </strong>{{ props.row.state || 'None' }}</p>
              <p><strong>Postcode: </strong>{{ props.row.postcode || 'None' }}</p>
            </el-col>
            <el-col :md="8">
              <p><strong>Contact: </strong>{{ props.row.contact || 'None' }}</p>
              <p><strong>Phone: </strong>{{ props.row.phone || 'None' }}</p>
              <p><strong>Fax: </strong>{{ props.row.fax || 'None' }}</p>
              <p><strong>Email: </strong>{{ props.row.email || 'None' }}</p>
            </el-col>
            <el-col :md="8">
              <p><strong>Notes: </strong></p>
              <p style="background-Color: #F5F5F5; padding: 5px;">
                {{ props.row.notes || 'None' }}
              </p>
            </el-col>
          </el-row>
        </template>
      </el-table-column>
      <el-table-column
        label="Name"
        prop="name"
        :formatter="(row, col, cellValue) => cellValue || '-'"
      />
      <el-table-column
        label="Address"
        prop="address"
        :formatter="(row, col, cellValue) => cellValue || '-'"
      />
      <el-table-column
        label="Suburb"
        prop="suburb"
        :formatter="(row, col, cellValue) => cellValue || '-'"
      />
      <el-table-column
        label="State"
        prop="state"
        :formatter="(row, col, cellValue) => cellValue || '-'"
      />
      <el-table-column
        label="Postcode"
        prop="postcode"
        :formatter="(row, col, cellValue) => cellValue || '-'"
      />
      <el-table-column
        v-if="canUpdate || canDelete"
        label="Actions"
        align="right"
      >
        <template slot-scope="scope">
          <el-button
            v-if="canUpdate"
            size="mini"
            @click.native="editLocation(scope.$index, scope.row)"
          >
            Edit
          </el-button>
          <el-button
            v-if="canDelete"
            size="mini"
            type="danger"
            @click.native="deleteLocation(scope.$index, scope.row)"
          >
            Delete
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- Pagination -->
    <br>
    <div style="text-align: center;">
      <el-pagination
        :current-page.sync="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size.sync="perPage"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="loadTable()"
        @current-change="loadTable()"
      />
    </div>
    <!-- Edit Form -->
    <LocationEditForm
      ref="editForm"
      :account-id="accountId"
      @saved="loadTable"
    />
  </div>
</template>

<script>
import LocationEditForm from '@/components/Application/CustomerService/Accounts/Account/Locations/LocationEditForm'
import { CREATE, UPDATE, DELETE } from '@/plugins/user'
export default {
  components: {
    LocationEditForm
  },
  props: {
    accountId: {
      type: String,
      required: true
    },
    filters: {
      type: Array,
      required: false,
      default: () => { return [] }
    }
  },
  data () {
    return {
      locations: [],
      page: 1,
      perPage: 10,
      total: 0,
      isLoading: true
    }
  },
  computed: {
    canUpdate () {
      return this.$user.can(UPDATE, 'account_location')
    },
    canDelete () {
      return this.$user.can(DELETE, 'account_location')
    }
  },
  mounted () {
    this.actions = [
      {
        hidden: this.$user.cannot(CREATE, 'account_location'),
        name: 'Create',
        icon: ['fal', 'plus'],
        event: () => {
          this.$refs.editForm.location = {}
          this.$refs.editForm.isShow = true
        }
      },
      {
        name: 'Refresh',
        icon: ['fal', 'sync'],
        event: () => this.loadTable()
      }
    ]
  },
  methods: {
    loadTable () {
      this.isLoading = true
      this.$sdk.account_location.list(builder => {
        builder.context = { resource: 'account', id: this.accountId }
        builder.filters = this.filters
        builder.page = this.page
        builder.limit = this.perPage
        builder.order = 'uuid:asc'
      })
        .then(res => {
          this.locations = res
          this.total = res.total
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    editLocation (index, row) {
      this.$refs.editForm.location = row
      this.$refs.editForm.isShow = true
    },
    deleteLocation (index, row) {
      this.$confirm('Are you sure to delete this location?', 'Delete', {
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.isLoading = true
        row.delete(builder => {
          builder.context = { resource: 'account', id: this.accountId }
        })
          .then(() => this.$message({ message: 'Successfully deleted', type: 'success' }))
          .finally(() => this.loadTable())
      }).catch(() => {})
    }
  }
}
</script>

<style>

</style>
